// Global functions (run on all pages)
/* global AOS, ScrollTrigger, gsap */

function initCustomCursor() {
  // Create cursor container (tracks mouse, stays fixed size)
  const cursorContainer = document.createElement("div");
  cursorContainer.classList.add("cursor-container");

  // Create visible cursor element (handles all visual effects)
  const cursorElement = document.createElement("div");
  cursorElement.classList.add("cursor-element");

  cursorContainer.appendChild(cursorElement);
  document.body.appendChild(cursorContainer);

  // Track mouse position and update container
  document.addEventListener("mousemove", (e) => {
    // Container follows mouse exactly, centered on cursor point
    cursorContainer.style.left = `${e.clientX}px`;
    cursorContainer.style.top = `${e.clientY}px`;
  });

  // Elements that should trigger cursor growth

  const hoverElements =
    'a, button, label, .hover-effect, [role="button"], input[type="submit"], input[type="button"], .button-primary, .button-secondary, .carousel-dot, .snap-indicator__dot-wrapper, .carousel-button, .swatch, .scroll-arrow, [data-open], [data-close],input[type="text"], input[type="email"], input[type="tel"], input[type="url"], input[type="password"], textarea, select';

  // Add hover effects with null check
  document.addEventListener(
    "mouseenter",
    (e) => {
      if (e.target?.matches?.(hoverElements)) {
        cursorElement.classList.add("cursor-hover");
      }
    },
    true,
  );

  document.addEventListener(
    "mouseleave",
    (e) => {
      if (e.target?.matches?.(hoverElements)) {
        cursorElement.classList.remove("cursor-hover");
      }
    },
    true,
  );

  // Hide cursor when leaving window

  document.addEventListener("mouseleave", () => {
    cursorContainer.style.opacity = "0";
  });

  document.addEventListener("mouseenter", () => {
    cursorContainer.style.opacity = "1";
  });

  // Handle iframe cursor visibility
  function handleIframes() {
    const iframes = document.querySelectorAll("iframe");

    iframes.forEach((iframe) => {
      // Hide custom cursor when mouse enters iframe
      iframe.addEventListener("mouseenter", () => {
        cursorContainer.style.opacity = "0";
        // Restore default cursor for iframe area
        iframe.style.cursor = "auto";
      });

      // Show custom cursor when mouse leaves iframe
      iframe.addEventListener("mouseleave", () => {
        cursorContainer.style.opacity = "1";
        // Remove default cursor
        iframe.style.cursor = "none";
      });

      // Initially hide default cursor on iframe
      iframe.style.cursor = "none";
    });
  }

  // Hide default cursor on all elements

  document.body.style.cursor = "none";
  document.querySelectorAll("*").forEach((el) => {
    el.style.cursor = "none";
  });

  // Handle existing iframes
  handleIframes();

  // Watch for dynamically added iframes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Element node
          if (node.tagName === "IFRAME") {
            // New iframe added
            node.style.cursor = "none";
            node.addEventListener("mouseenter", () => {
              cursorContainer.style.opacity = "0";
              node.style.cursor = "auto";
            });
            node.addEventListener("mouseleave", () => {
              cursorContainer.style.opacity = "1";
              node.style.cursor = "none";
            });
          } else if (node.querySelectorAll) {
            // Check if added element contains iframes
            const newIframes = node.querySelectorAll("iframe");
            newIframes.forEach((iframe) => {
              iframe.style.cursor = "none";
              iframe.addEventListener("mouseenter", () => {
                cursorContainer.style.opacity = "0";
                iframe.style.cursor = "auto";
              });
              iframe.addEventListener("mouseleave", () => {
                cursorContainer.style.opacity = "1";
                iframe.style.cursor = "none";
              });
            });
          }
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function initGlobalFeatures() {
  // AOS initialization
  AOS.init();

  // Resize handling
  let resizeTimeout;
  let lastInnerHeight = window.innerHeight;
  let lastInnerWidth = window.innerWidth;

  function isSignificantResize(newHeight, newWidth) {
    const heightDiff = Math.abs(newHeight - lastInnerHeight);
    const widthDiff = Math.abs(newWidth - lastInnerWidth);
    const significantHeightChange = heightDiff > 120;
    const significantWidthChange = widthDiff > 50;

    return significantHeightChange || significantWidthChange;
  }

  window.addEventListener("resize", function () {
    const newHeight = window.innerHeight;
    const newWidth = window.innerWidth;

    if (isSignificantResize(newHeight, newWidth)) {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (typeof ScrollTrigger !== "undefined") {
          ScrollTrigger.refresh();
        }
        if (typeof AOS !== "undefined") {
          AOS.refresh();
        }
        lastInnerHeight = newHeight;
        lastInnerWidth = newWidth;
      }, 300);
    }
  });

  window.addEventListener("orientationchange", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (typeof ScrollTrigger !== "undefined") {
        ScrollTrigger.refresh();
      }
      if (typeof AOS !== "undefined") {
        AOS.refresh();
      }
      lastInnerHeight = window.innerHeight;
      lastInnerWidth = window.innerWidth;
    }, 500);
  });
}

function initModalFeatures() {
  // Modal functionality
  document.querySelectorAll("[data-open]").forEach((trigger) => {
    trigger.addEventListener("click", () => {
      document.body.style.overflow = "hidden";

      const modalId = trigger.getAttribute("data-open");
      const modal = document.querySelector(`[data-modal="${modalId}"]`);
      const header = document.querySelector("header.header");
      console.log("Opening modal:", modalId);
      // Update ARIA attributes on the trigger button
      trigger.setAttribute("aria-expanded", "true");
      trigger.setAttribute("aria-hidden", "true");

      // Update corresponding close button if it exists
      const closeButton = document.querySelector(`[data-close="${modalId}"]`);
      if (closeButton) {
        closeButton.setAttribute("aria-expanded", "true");
        closeButton.setAttribute("aria-hidden", "false");
      }

      if (modal && "gallery" === modalId) {
        const galleryWrapper = modal.querySelector(".gallery-wrapper");

        // Mark clicked item and add transitioning state
        trigger.classList.add("active-slide");
        galleryWrapper.classList.add("transitioning");

        modal.classList.add("expanded");

        // Update ARIA attributes for accessibility
        modal.setAttribute("aria-hidden", "false");
        modal.removeAttribute("tabindex");
        modal.focus();

        // Wait for opacity transition to complete before scrolling
        setTimeout(() => {
          trigger.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start",
          });
        }, 300);

        setTimeout(() => {
          galleryWrapper.classList.remove("transitioning");
          trigger.classList.remove("active-slide");
        }, 1000);
      } else if (modal) {
        if (header && modalId === "nav-drawer") {
          header.classList.add("menu-open");
        } else if (modalId === "technical-specs") {
          // modal.setAttribute("open", "");
          modal.classList.add("open");
        } else {
          modal.style.display = "block";
        }

        // Update ARIA attributes for accessibility
        modal.setAttribute("aria-hidden", "false");
        modal.removeAttribute("tabindex");
        modal.focus();
      }

      // Only trigger gtag event if it's not the nav-drawer
      if (modalId !== "nav-drawer") {
        //eslint-disable-next-line no-undef
        gtag("event", "open_modal", {
          open_id: modalId,
        });
      }
    });
  });

  document.querySelectorAll("[data-close]").forEach((trigger) => {
    console.log("Adding close listener to trigger:", trigger);
    trigger.addEventListener("click", () => {
      document.body.style.overflow = "";
      const modalId = trigger.getAttribute("data-close");
      const modal = document.querySelector(`[data-modal="${modalId}"]`);
      const header = document.querySelector("header.header");

      // Update ARIA attributes on the trigger button
      trigger.setAttribute("aria-expanded", "false");
      trigger.setAttribute("aria-hidden", "true");

      // Update corresponding open button if it exists
      const openButton = document.querySelector(`[data-open="${modalId}"]`);
      if (openButton) {
        openButton.setAttribute("aria-expanded", "false");
        openButton.setAttribute("aria-hidden", "false");
      }

      if (modal && "gallery" === modalId) {
        modal.classList.remove("expanded");

        // Update ARIA attributes for accessibility
        modal.setAttribute("aria-hidden", "true");
        modal.setAttribute("tabindex", "-1");
      } else if (modal) {
        if (header && modalId === "nav-drawer") {
          header.classList.remove("menu-open");
        } else if (modalId === "technical-specs") {
          modal.classList.remove("open");
        } else {
          modal.style.display = "none";
        }

        // Update ARIA attributes for accessibility
        modal.setAttribute("aria-hidden", "true");
        modal.setAttribute("tabindex", "-1");
      }

      // Return focus to the trigger that opened the modal
      const openTrigger = document.querySelector(`[data-open="${modalId}"]`);
      if (openTrigger) {
        openTrigger.focus();
      }
    });
  });

  // Modal Navigation Image Hover Logic
  const navLinks = document.querySelectorAll(
    ".primary-nav a[data-menu-item-id]",
  );
  const modalImageContainer = document.querySelector(
    ".modal-navigation .modal-image",
  );
  // The first image is the default state (either the first custom image or the fallback default)
  const defaultImage = modalImageContainer
    ? modalImageContainer.querySelector(".nav-hover-image")
    : null;

  if (
    navLinks.length &&
    modalImageContainer &&
    window.matchMedia("(hover: hover)").matches
  ) {
    navLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        const itemId = link.getAttribute("data-menu-item-id");

        // Deactivate all first
        const allImages =
          modalImageContainer.querySelectorAll(".nav-hover-image");
        allImages.forEach((img) => {
          img.classList.remove("is-active");
          img.setAttribute("aria-hidden", "true");
        });

        // Try to find specific image for this item
        let targetImage = document.getElementById(`nav-img-${itemId}`);

        // If no specific image exists for this link, fallback to the default (first) image
        if (!targetImage && defaultImage) {
          targetImage = defaultImage;
        }

        if (targetImage) {
          targetImage.classList.add("is-active");
          targetImage.setAttribute("aria-hidden", "false");
        }
      });
    });
  }

  // Add Escape key handler for closing modals
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      // Find all open modals
      const openModals = document.querySelectorAll(
        '[data-modal]:not([aria-hidden="true"])',
      );

      openModals.forEach((modal) => {
        const modalId = modal.getAttribute("data-modal");
        const closeButton = document.querySelector(`[data-close="${modalId}"]`);

        // Trigger the close button click to ensure all cleanup happens
        if (closeButton) {
          closeButton.click();
        }
      });
    }
  });

  // Close modal when clicking the backdrop
  const backdrop = document.querySelector(".backdrop");
  if (backdrop) {
    backdrop.addEventListener("click", () => {
      const openModals = document.querySelectorAll(
        '[data-modal]:not([aria-hidden="true"])',
      );

      openModals.forEach((modal) => {
        const modalId = modal.getAttribute("data-modal");
        const closeButton = document.querySelector(`[data-close="${modalId}"]`);

        if (closeButton) {
          closeButton.click();
        }
      });
    });
  }
}

// Home page specific functions
function initHomePageFeatures() {
  console.log("Initializing home page features...");
  // Carousel controls
  // Scroll indicator dots
  const snapIndicator = document.querySelector(".snap-indicator");
  const sections = document.querySelectorAll(".section");

  //for each section add a snap indicator dot
  sections.forEach((section, index) => {
    const dotWrapper = document.createElement("div");
    dotWrapper.classList.add("snap-indicator__dot-wrapper");

    const dot = document.createElement("div");
    dot.classList.add("snap-indicator__dot");

    // Add active class to first dot wrapper
    if (index === 0) {
      dotWrapper.classList.add("active");
    }

    dotWrapper.appendChild(dot);
    snapIndicator.appendChild(dotWrapper);

    // Create indicator ScrollTriggers after other animations
    ScrollTrigger.addEventListener("refresh", () => {
      ScrollTrigger.create({
        trigger: section,

        start: "top 90%", // Compromise between early and late
        end: "bottom 90%",
        onEnter: () => updateActiveIndicator(index),
        onEnterBack: () => updateActiveIndicator(index),
      });
    });
  });

  // Function to update active indicator
  function updateActiveIndicator(activeIndex) {
    const allDotWrappers = snapIndicator.querySelectorAll(
      ".snap-indicator__dot-wrapper",
    );
    const currentSection = sections[activeIndex];

    // Remove active class from all dot wrappers

    allDotWrappers.forEach((wrapper) => wrapper.classList.remove("active"));

    // Add active class to current dot wrapper
    if (allDotWrappers[activeIndex]) {
      allDotWrappers[activeIndex].classList.add("active");
    }

    // Toggle light class based on section background
    if (currentSection.classList.contains("dark-bg")) {
      snapIndicator.classList.add("light");
    } else {
      snapIndicator.classList.remove("light");
    }
  }

  const carousel = document.querySelector(".section-four .carousel-wrapper");

  // Check if carousel exists
  if (!carousel) return;

  // Target the slides track instead of carousel wrapper
  const slidesTrack = carousel.querySelector(".slides-track");
  const slides = carousel.querySelectorAll(".section-four .slide");
  const dots = carousel.querySelectorAll(".carousel-dot");
  const nextBtn = carousel.querySelector(".carousel-button-next");
  const prevBtn = carousel.querySelector(".carousel-button-prev");

  // Check if we have slides and required elements
  if (!slides.length || !dots.length || !nextBtn || !prevBtn || !slidesTrack)
    return;

  let currentSlide = 0;
  let autoplayInterval;
  let carouselActive = false;

  // Update carousel position and active states
  function updateCarousel() {
    if (slides.length === 0) return;

    const slideWidth = slides[0].offsetWidth;
    // Scroll the slides track, not the carousel wrapper
    slidesTrack.scrollTo({
      left: slideWidth * currentSlide,
      behavior: "smooth",
    });

    // Update active states for both dots and slides
    updateActiveStates();
  }

  function updateActiveStates() {
    // Remove active class from all dots and slides
    dots.forEach((dot) => dot.classList.remove("active"));
    slides.forEach((slide) => slide.classList.remove("active"));

    // Add active class to current dot and slide
    if (dots[currentSlide]) {
      dots[currentSlide].classList.add("active");

      // Force CSS animation restart by removing and re-adding class
      dots[currentSlide].offsetHeight; // Trigger reflow
      dots[currentSlide].classList.remove("active");
      dots[currentSlide].classList.add("active");
    }

    if (slides[currentSlide]) {
      slides[currentSlide].classList.add("active");
    }
  }

  // Go to specific slide
  function goToSlide(slideIndex) {
    if (!carouselActive || isTransitioning) return;
    currentSlide = slideIndex;
    updateCarousel();
    resetAutoplay();
  }

  // Next slide
  function nextSlide() {
    if (!carouselActive || isTransitioning) return;
    currentSlide = (currentSlide + 1) % slides.length;
    updateCarousel();
  }

  // Previous slide
  function prevSlide() {
    if (!carouselActive || isTransitioning) return;
    currentSlide = currentSlide === 0 ? slides.length - 1 : currentSlide - 1;
    updateCarousel();
  }

  // Start autoplay
  function startAutoplay() {
    if (!carouselActive) return;
    // Clear any existing interval first
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
    }
    autoplayInterval = setInterval(() => {
      nextSlide();
    }, 6000);
  }

  // Stop autoplay
  function stopAutoplay() {
    if (autoplayInterval) {
      clearInterval(autoplayInterval);
      autoplayInterval = null;
    }
  }

  // Reset autoplay (only for manual interactions)
  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  // Event handlers (separated for easier removal)
  const handleNext = () => {
    nextSlide();
    resetAutoplay();
  };

  const handlePrev = () => {
    prevSlide();
    resetAutoplay();
  };

  // Add touch/swipe variables after the existing carousel variables
  let touchStartX = 0;
  let touchEndX = 0;
  let touchStartY = 0;
  let touchEndY = 0;
  let isSwiping = false;
  let swipeThreshold = 50; // Minimum distance for a swipe
  let verticalThreshold = 30; // Maximum vertical movement to still count as horizontal swipe

  // Touch event handlers
  function handleTouchStart(e) {
    if (!carouselActive || isTransitioning) return;
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    isSwiping = true;

    // Stop autoplay during touch interaction
    stopAutoplay();
  }

  function handleTouchMove(e) {
    if (!isSwiping || !carouselActive || isTransitioning) return;
    // Prevent default scrolling if it's a horizontal swipe
    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const deltaX = Math.abs(currentX - touchStartX);
    const deltaY = Math.abs(currentY - touchStartY);
    // If horizontal movement is greater than vertical, prevent default
    if (deltaX > deltaY && deltaX > 10) {
      e.preventDefault();
    }
  }

  function handleTouchEnd(e) {
    if (!isSwiping || !carouselActive || isTransitioning) return;
    touchEndX = e.changedTouches[0].clientX;
    touchEndY = e.changedTouches[0].clientY;

    handleSwipe();
    isSwiping = false;
    // Restart autoplay after touch interaction
    resetAutoplay();
  }

  function handleSwipe() {
    const deltaX = touchEndX - touchStartX;
    const deltaY = Math.abs(touchEndY - touchStartY);

    // Check if it's a horizontal swipe (not vertical scroll)
    if (Math.abs(deltaX) < swipeThreshold || deltaY > verticalThreshold) {
      return; // Not a valid swipe
    }
    if (deltaX > 0) {
      // Swipe right - go to previous slide
      prevSlide();
    } else {
      // Swipe left - go to next slide
      nextSlide();
    }
  }

  // Activate carousel - only when called
  function activateCarousel() {
    if (carouselActive) return;

    carouselActive = true;

    // Show carousel controls with smooth transition
    gsap.to([nextBtn, prevBtn, ...dots], {
      opacity: 1,
      duration: 0.3,
      ease: "power2.out",
    });

    // Refresh the active dot animation to sync with activation
    if (dots[currentSlide]) {
      // Force CSS animation restart by removing and re-adding class
      dots[currentSlide].classList.remove("active");
      dots[currentSlide].offsetHeight; // Trigger reflow
      dots[currentSlide].classList.add("active");
    }

    // Add event listeners
    nextBtn.addEventListener("click", handleNext);
    prevBtn.addEventListener("click", handlePrev);

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goToSlide(index));
    });

    // Try adding touch listeners to carousel wrapper
    carousel.addEventListener("touchstart", handleTouchStart, {
      passive: false,
    });
    carousel.addEventListener("touchmove", handleTouchMove, { passive: false });
    carousel.addEventListener("touchend", handleTouchEnd, { passive: true });

    // Also try the buttons container if it exists
    const buttonsContainer = carousel.querySelector(".carousel-buttons");
    if (buttonsContainer) {
      buttonsContainer.addEventListener("touchstart", handleTouchStart, {
        passive: false,
      });
      buttonsContainer.addEventListener("touchmove", handleTouchMove, {
        passive: false,
      });
      buttonsContainer.addEventListener("touchend", handleTouchEnd, {
        passive: true,
      });
    }
  }

  // Deactivate carousel and lock current slide
  function deactivateCarousel() {
    if (!carouselActive) return;

    carouselActive = false;

    // Hide carousel controls with smooth transition
    gsap.to([nextBtn, prevBtn, ...dots], {
      opacity: 0,
      duration: 0.3,
      ease: "power2.out",
    });

    // Remove event listeners
    nextBtn.removeEventListener("click", handleNext);
    prevBtn.removeEventListener("click", handlePrev);

    // Remove touch event listeners from carousel wrapper
    carousel.removeEventListener("touchstart", handleTouchStart);
    carousel.removeEventListener("touchmove", handleTouchMove);
    carousel.removeEventListener("touchend", handleTouchEnd);

    // Remove from buttons container if it exists
    const buttonsContainer = carousel.querySelector(".carousel-buttons");
    if (buttonsContainer) {
      buttonsContainer.removeEventListener("touchstart", handleTouchStart);
      buttonsContainer.removeEventListener("touchmove", handleTouchMove);
      buttonsContainer.removeEventListener("touchend", handleTouchEnd);
    }

    // Stop autoplay
    stopAutoplay();
  }

  // Reset to first slide (only used on initial load)
  function resetToFirstSlide() {
    currentSlide = 0;
    updateCarousel();
  }

  // Initialize carousel in proper state
  function initializeCarousel() {
    // Hide all controls initially
    gsap.set([nextBtn, prevBtn, ...dots], { opacity: 0 });

    // Show only first slide
    resetToFirstSlide();

    // Ensure carousel is deactivated
    carouselActive = false;
  }

  // Initialize carousel
  initializeCarousel();

  // Modal functionality
  // document.querySelectorAll("[data-open]").forEach((trigger) => {
  // 	console.log("Adding open listener to trigger:", trigger);
  // 	trigger.addEventListener("click", () => {
  // 		document.body.style.overflow = "hidden";

  // 		const modalId = trigger.getAttribute("data-open");
  // 		const modal = document.querySelector(`[data-modal="${modalId}"]`);
  // 		console.log("Opening modal:", modalId);
  // 		console.log(modal);
  // 		// Update ARIA attributes on the trigger button
  // 		trigger.setAttribute("aria-expanded", "true");
  // 		trigger.setAttribute("aria-hidden", "true");

  // 		// Update corresponding close button if it exists
  // 		const closeButton = document.querySelector(`[data-close="${modalId}"]`);
  // 		if (closeButton) {
  // 			closeButton.setAttribute("aria-expanded", "true");
  // 			closeButton.setAttribute("aria-hidden", "false");
  // 		}

  // 		if (modal && "gallery" === modalId) {
  // 			const galleryWrapper = modal.querySelector(".gallery-wrapper");

  // 			// Mark clicked item and add transitioning state
  // 			trigger.classList.add("active-slide");
  // 			galleryWrapper.classList.add("transitioning");

  // 			modal.classList.add("expanded");

  // 			// Update ARIA attributes for accessibility
  // 			modal.setAttribute("aria-hidden", "false");
  // 			modal.removeAttribute("tabindex");
  // 			modal.focus();

  // 			// Wait for opacity transition to complete before scrolling
  // 			setTimeout(() => {
  // 				trigger.scrollIntoView({
  // 					behavior: "smooth",
  // 					block: "nearest",
  // 					inline: "start",
  // 				});
  // 			}, 300);

  // 			setTimeout(() => {
  // 				galleryWrapper.classList.remove("transitioning");
  // 				trigger.classList.remove("active-slide");
  // 			}, 1000);
  // 		} else if (modal) {
  // 			modal.style.display = "block";

  // 			// Update ARIA attributes for accessibility
  // 			modal.setAttribute("aria-hidden", "false");
  // 			modal.removeAttribute("tabindex");
  // 			modal.focus();
  // 		}

  // 		// Only trigger gtag event if it's not the nav-drawer
  // 		if (modalId !== "nav-drawer") {
  // 			//eslint-disable-next-line no-undef
  // 			gtag("event", "open_modal", {
  // 				open_id: modalId,
  // 			});
  // 		}
  // 	});
  // });

  // document.querySelectorAll("[data-close]").forEach((trigger) => {
  // 	console.log("Adding close listener to trigger:", trigger);
  // 	trigger.addEventListener("click", () => {
  // 		document.body.style.overflow = "";
  // 		const modalId = trigger.getAttribute("data-close");
  // 		const modal = document.querySelector(`[data-modal="${modalId}"]`);

  // 		// Update ARIA attributes on the trigger button
  // 		trigger.setAttribute("aria-expanded", "false");
  // 		trigger.setAttribute("aria-hidden", "true");

  // 		// Update corresponding open button if it exists
  // 		const openButton = document.querySelector(`[data-open="${modalId}"]`);
  // 		if (openButton) {
  // 			openButton.setAttribute("aria-expanded", "false");
  // 			openButton.setAttribute("aria-hidden", "false");
  // 		}

  // 		if (modal && "gallery" === modalId) {
  // 			modal.classList.remove("expanded");

  // 			// Update ARIA attributes for accessibility
  // 			modal.setAttribute("aria-hidden", "true");
  // 			modal.setAttribute("tabindex", "-1");
  // 		} else if (modal) {
  // 			modal.style.display = "none";

  // 			// Update ARIA attributes for accessibility
  // 			modal.setAttribute("aria-hidden", "true");
  // 			modal.setAttribute("tabindex", "-1");
  // 		}

  // 		// Return focus to the trigger that opened the modal
  // 		const openTrigger = document.querySelector(`[data-open="${modalId}"]`);
  // 		if (openTrigger) {
  // 			openTrigger.focus();
  // 		}
  // 	});
  // });

  // Add scroll progress bar functionality
  const galleryWrapper = document.querySelector(".gallery-wrapper");
  const scrollBar = document.querySelector(".scroll-bar");
  if (galleryWrapper && scrollBar) {
    const leftArrow = document.querySelector(".arrow-left");
    const rightButton = document.querySelector(
      ".scroll-indicator .button-secondary",
    );

    galleryWrapper.addEventListener("scroll", () =>
      updateNavigationVisibility(leftArrow, rightButton),
    );

    // Initialize visibility on load
    updateNavigationVisibility(leftArrow, rightButton);
  }

  function updateNavigationVisibility(leftArrow, rightButton) {
    const scrollLeft = galleryWrapper.scrollLeft;
    const scrollWidth = galleryWrapper.scrollWidth - galleryWrapper.clientWidth;
    const scrollPercentage = (scrollLeft / scrollWidth) * 100;

    // Update scroll progress bar
    scrollBar.style.setProperty("--scroll-progress", `${scrollPercentage}%`);

    // Hide left arrow at beginning (0% scrolled)
    if (leftArrow) {
      leftArrow.style.opacity = scrollLeft <= 0 ? "0" : "1";
    }

    // Hide right button at end (100% scrolled)
    if (rightButton) {
      rightButton.style.opacity = scrollLeft >= scrollWidth ? "0" : "1";
    }
  }

  // Gallery arrow navigation
  const leftArrow = document.querySelector(".scroll-indicator .arrow-left");
  const rightButton = document.querySelector(
    ".scroll-indicator .button-secondary",
  );

  if (galleryWrapper && leftArrow && rightButton) {
    const computedStyle = getComputedStyle(galleryWrapper);
    const columnWidth =
      parseFloat(computedStyle.getPropertyValue("--column-width")) || 300;
    const gap = parseFloat(computedStyle.gap) || 10;

    leftArrow.addEventListener("click", () => {
      galleryWrapper.scrollBy({
        left: -(columnWidth + gap),
        behavior: "smooth",
      });
    });

    rightButton.addEventListener("click", () => {
      galleryWrapper.scrollBy({
        left: columnWidth + gap,
        behavior: "smooth",
      });
    });
  }

  //GSAP Controls

  let exploreMore = document.querySelector(".indicator-explore");
  if (exploreMore) {
    gsap.to(exploreMore, {
      scrollTrigger: {
        trigger: exploreMore,
        start: "center 65%",
        // markers: true,
      },
      opacity: 0,
      once: true,
    });
  }

  let sectionTwo = document.querySelector(".section-two");
  if (sectionTwo) {
    const bgImg = sectionTwo.querySelector(".bg-img");

    if (bgImg) {
      // Create ScrollTrigger that activates just before section enters viewport
      ScrollTrigger.create({
        trigger: sectionTwo,
        start: "top bottom", // Triggers 50px before "top bottom"
        end: "bottom top",

        onEnter: () => {
          // Pin the background image in place when section is about to enter
          gsap.set(bgImg, {
            display: "block",
          });
        },

        onLeave: () => {
          gsap.set(bgImg, { display: "none" });
        },

        onEnterBack: () => {
          gsap.set(bgImg, {
            display: "block",
          });
        },

        onLeaveBack: () => {
          // Reset to original state when scrolling back up
          gsap.set(bgImg, {
            display: "none",
          });
        },
      });
    }
  }

  let sectionFour = document.querySelector(".section-four");
  let sectionFourGallery = document.querySelector(
    ".section-four .carousel-wrapper",
  );

  // Declare transition state variables
  let isTransitioning = false;
  let unlockTimer = null;

  // Lock the current slide using CSS class
  function lockCurrentSlide() {
    if (slides.length === 0 || currentSlide === 0 || isTransitioning) return;
    isTransitioning = true;
    // Add transitioning class to current slide
    if (slides[currentSlide]) {
      slides[currentSlide].classList.add("transitioning");
    }
  }

  // Unlock the slide by removing CSS class
  function unlockCurrentSlide() {
    if (!isTransitioning) return;
    // Remove transitioning class from current slide
    if (slides[currentSlide]) {
      slides[currentSlide].classList.remove("transitioning");
    }

    // Reset positioning to match current carousel state
    requestAnimationFrame(() => {
      const slideWidth = slides[0].offsetWidth;
      const targetScrollLeft = slideWidth * currentSlide;
      slidesTrack.scrollLeft = targetScrollLeft;

      // Clean up
      isTransitioning = false;
    });
  }

  // Schedule unlock after inactivity
  function scheduleUnlock() {
    // Clear any existing timer
    if (unlockTimer) {
      clearTimeout(unlockTimer);
    }

    // Set new timer to unlock after 500ms of inactivity
    unlockTimer = setTimeout(() => {
      if (isTransitioning) {
        unlockCurrentSlide();
      }
    }, 500);
  }

  if (sectionFour) {
    // Detect mobile
    const isMobile = window.innerWidth <= 768;

    ScrollTrigger.create({
      trigger: sectionFour,
      start: "center center",
      end: "bottom center",
      pin: true,
      pinSpacing: true,
      // markers: true,
      id: "section-four-pin",
      onRefresh: () => {
        // Refresh AOS calculations when ScrollTrigger recalculates
        if (typeof AOS !== "undefined") {
          AOS.refresh();
        }
      },
      onToggle: () => {
        // Refresh AOS when pin state changes
        if (typeof AOS !== "undefined") {
          AOS.refresh();
        }
      },
    });

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionFour,
        start: "center center",
        end: "bottom 75%",
        scrub: isMobile ? 0.3 : 1,
        // markers: true,
        id: "section-four-tl",
        onUpdate: (self) => {
          // Lock slide during any transition if not on first slide
          if (currentSlide > 0 && !isTransitioning) {
            lockCurrentSlide();
          }

          // Schedule unlock after each update (resets timer)
          if (isTransitioning) {
            scheduleUnlock();
          }

          // Check if animation is at or near completion (50%+)
          if (self.progress >= 0.5 && !carouselActive) {
            // Animation nearly complete - activate carousel
            activateCarousel();
            startAutoplay();
          } else if (self.progress < 0.5 && carouselActive) {
            // Animation reversed or not complete - deactivate carousel
            deactivateCarousel();
          }
        },
      },
    });

    tl.to(sectionFourGallery, {
      maxWidth: "100vw",
      height: "100%",
      paddingInline: "0",
    });

    // ScrollTrigger to control carousel after timeline completion and pin release
    ScrollTrigger.create({
      trigger: sectionFour,
      start: "top top-=125px", // Same as pin end point
      end: "bottom 85%", // Buffer zone for deactivation
      // markers: true,
      id: "section-four-carousel-control",
      onEnter: () => {
        deactivateCarousel();
        if (unlockTimer) {
          clearTimeout(unlockTimer);
        }
        unlockCurrentSlide();
      },
      onLeave: () => {
        deactivateCarousel();
        if (unlockTimer) {
          clearTimeout(unlockTimer);
        }
        unlockCurrentSlide();
      },
      onEnterBack: () => {
        // Reactivate carousel if timeline is complete (you may need to check progress)
        // This depends on your specific UX requirements
        if (!carouselActive) {
          activateCarousel();
          startAutoplay();
        }
      },
      onLeaveBack: () => {
        // Timeline will handle reactivation as user scrolls back up
      },
    });
  }

  //allow immediate jump to section
  document.querySelectorAll('a[href="#models"]').forEach((link) => {
    link.addEventListener("click", function () {
      // Temporarily disable smooth scrolling
      const html = document.documentElement;
      const originalBehavior = html.style.scrollBehavior;
      html.style.scrollBehavior = "auto";

      // Allow default anchor behavior but without smooth scroll
      setTimeout(() => {
        html.style.scrollBehavior = originalBehavior;
      }, 100);
    });
  });
}

function initGalleryScrollTracking() {
  const galleryWrapper = document.querySelector(".gallery-wrapper");
  if (!galleryWrapper) return;

  let lastScrollLeft = galleryWrapper.scrollLeft;
  let scrollTimeout;
  const minScrollDistance = 50; // Minimum pixels to consider significant

  galleryWrapper.addEventListener(
    "scroll",
    function () {
      // Clear existing timeout
      clearTimeout(scrollTimeout);

      // Debounce to avoid too many events
      scrollTimeout = setTimeout(() => {
        const currentScrollLeft = galleryWrapper.scrollLeft;
        const scrollDistance = Math.abs(currentScrollLeft - lastScrollLeft);

        // Only track significant movements
        if (scrollDistance > minScrollDistance) {
          // eslint-disable-next-line no-undef
          gtag("event", "gallery_scroll", {
            gallery_section: "section-six",
          });

          lastScrollLeft = currentScrollLeft;
        }
      }, 150); // 150ms debounce
    },
    { passive: true },
  );
}

function initGoogleTagEvents() {
  initGalleryScrollTracking();

  // Custom CTA tracking for specific buttons
  document.querySelectorAll("[data-cta-id]").forEach((element) => {
    element.addEventListener("click", function () {
      // eslint-disable-next-line no-undef
      gtag("event", "cta_click", {
        element_text: this.textContent.trim(),
        element_url: this.href || "",
        element_class: this.className,
        cta_id: this.dataset.ctaId,
        cta_section: this.dataset.ctaSection || "unknown",
      });
    });
  });

  document.querySelectorAll("a:not([data-cta-id])").forEach((element) => {
    element.addEventListener("click", function () {
      // eslint-disable-next-line no-undef
      gtag("event", "link_click", {
        link_text: this.textContent.trim(),
        link_url: this.href || "",
        cta_id: this.dataset.link || "",
        cta_section: this.dataset.ctaSection || "unknown",
      });
    });
  });

  document.querySelectorAll(".carousel-button").forEach((element) => {
    element.addEventListener("click", function () {
      // Get the button type from the SVG's class attribute
      const buttonType = this.querySelector("svg").classList.contains(
        "button-next",
      )
        ? "button-next"
        : "button-prev";
      // eslint-disable-next-line no-undef
      gtag("event", "carousel_interaction", {
        button_type: buttonType,
      });
    });
  });
}

function initNumberCounters() {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-animating");
          observer.unobserve(entry.target); // Animate once
        }
      });
    },
    {
      threshold: 0.5, // Trigger when 50% visible
    },
  );

  document.querySelectorAll(".stat-digit-wrapper").forEach((wrapper) => {
    observer.observe(wrapper);
  });
}

function initAccordion() {
  const accordionTriggers = document.querySelectorAll(
    ".spec-list__wrapper-label",
  );

  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function () {
      const parentWrapper = this.closest(".spec-list__wrapper");
      const isCurrentlyOpen = parentWrapper.classList.contains("is-open");

      // Get the container that holds all accordion items
      const accordionContainer = parentWrapper.parentElement;

      // Close all accordion items first
      document
        .querySelectorAll(".spec-list__wrapper.is-open")
        .forEach((wrapper) => {
          wrapper.classList.remove("is-open");
          const label = wrapper.querySelector(".spec-list__wrapper-label");
          const content = wrapper.querySelector(".spec-list");
          if (label) label.setAttribute("aria-expanded", "false");
          if (content) content.setAttribute("aria-hidden", "true");
        });

      // If clicked item wasn't open, open it then scroll
      if (!isCurrentlyOpen) {
        parentWrapper.classList.add("is-open");
        this.setAttribute("aria-expanded", "true");
        const content = parentWrapper.querySelector(".spec-list");
        if (content) content.setAttribute("aria-hidden", "false");

        // Wait for expansion animation to complete before scrolling
        setTimeout(() => {
          if (accordionContainer) {
            accordionContainer.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }, 250); // Wait for CSS transition (0.2s) plus small buffer
      }
    });

    // Add keyboard support
    trigger.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.click();
      }
    });
  });
}

function initSwatchControls() {
  const swatches = document.querySelectorAll(".swatch");

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      // 1. Handle Swatch State
      const parent = this.closest(".model-colors");
      if (!parent) return;

      // Deactivate siblings
      parent.querySelectorAll(".swatch").forEach((s) => {
        s.classList.remove("active");
        s.setAttribute("aria-pressed", "false");
      });

      // Activate clicked
      this.classList.add("active");
      this.setAttribute("aria-pressed", "true");

      // 2. Handle Image State
      const targetId = this.getAttribute("aria-controls");
      if (!targetId) return;

      const targetImage = document.getElementById(targetId);
      if (!targetImage) return;

      const imageWrapper = targetImage.closest(".pdp-stat-card__image-wrapper");
      if (!imageWrapper) return;

      // Deactivate sibling images
      imageWrapper.querySelectorAll(".pdp-stat-card__image").forEach((img) => {
        img.classList.remove("active");
        img.setAttribute("aria-hidden", "true");
      });

      // Activate target image
      targetImage.classList.add("active");
      targetImage.setAttribute("aria-hidden", "false");
    });

    // Add keyboard support (Enter/Space)
    swatch.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        this.click();
      }
    });
  });
}

function initPdpScrollIndicators() {
  if (window.innerWidth >= 768) return;

  const wrapper = document.querySelector(".pdp-stat-card__wrapper");
  const indicatorContainer = document.querySelector(
    ".pdp-stat-card__scroll-indicator",
  );

  if (!wrapper || !indicatorContainer) return;

  // Clear any existing content
  indicatorContainer.innerHTML = "";

  const cards = wrapper.children;
  const dots = [];

  // Generate dots based on number of cards
  Array.from(cards).forEach((_, index) => {
    const dot = document.createElement("div");
    dot.classList.add("indicator-dot");

    // Set initial colors and active state
    if (index === 0) {
      dot.classList.add("active");
      dot.style.backgroundColor = "black";
    } else {
      dot.style.backgroundColor = "rgb(215, 215, 217)";
    }

    indicatorContainer.appendChild(dot);
    dots.push(dot);
  });

  // Update active state on scroll
  wrapper.addEventListener(
    "scroll",
    () => {
      const scrollLeft = wrapper.scrollLeft;
      const cardWidth = cards[0].offsetWidth;
      // Calculate active index based on scroll position
      const activeIndex = Math.round(scrollLeft / cardWidth);

      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add("active");
          dot.style.backgroundColor = "black";
        } else {
          dot.classList.remove("active");
          dot.style.backgroundColor = "rgb(215, 215, 217)";
        }
      });
    },
    { passive: true },
  );
}

function initToggleHotspot() {
  const toggleTrack = document.getElementById("toggle-track-el");
  const radioExt = document.getElementById("radio-ext");
  const radioInt = document.getElementById("radio-int");
  const extEl = document.getElementById("image-exterior");
  const intEl = document.getElementById("image-interior");
  const labelExt = document.getElementById("label-ext");
  const labelInt = document.getElementById("label-int");
  const statusEl = document.getElementById("hotspot-view-status");

  // Require core elements
  if (!radioExt || !radioInt || !extEl || !intEl) return;

  // Get carousel elements for each view
  const extCarousel = document.getElementById("hotspot-carousel-exterior");
  const intCarousel = document.getElementById("hotspot-carousel-interior");

  function applyView(view) {
    const showEl = view === "exterior" ? extEl : intEl;
    const hideEl = view === "exterior" ? intEl : extEl;
    const showCarousel = view === "exterior" ? extCarousel : intCarousel;
    const hideCarousel = view === "exterior" ? intCarousel : extCarousel;

    // Toggle visibility and focusability for images
    showEl.hidden = false;
    showEl.removeAttribute("inert");
    showEl.classList.add("active");

    hideEl.hidden = true;
    hideEl.setAttribute("inert", "");
    hideEl.classList.remove("active");

    // Toggle visibility and focusability for carousels
    if (showCarousel) {
      showCarousel.hidden = false;
      showCarousel.removeAttribute("inert");
      showCarousel.setAttribute("aria-live", "polite");
    }
    if (hideCarousel) {
      hideCarousel.hidden = true;
      hideCarousel.setAttribute("inert", "");
      hideCarousel.setAttribute("aria-live", "off");
    }

    // Toggle visual labels
    if (labelExt && labelInt) {
      labelExt.classList.toggle("active", view === "exterior");
      labelInt.classList.toggle("active", view === "interior");
    }

    // Announce change
    if (statusEl) {
      statusEl.textContent =
        view === "exterior"
          ? "Exterior view displayed"
          : "Interior view displayed";
    }
  }

  // Radio change handlers (covers label clicks and keyboard)
  radioExt.addEventListener("change", () => {
    if (radioExt.checked) applyView("exterior");
  });
  radioInt.addEventListener("change", () => {
    if (radioInt.checked) applyView("interior");
  });

  // Track click toggles radios and dispatches change for consistency
  if (toggleTrack) {
    toggleTrack.addEventListener("click", () => {
      const nextView = radioExt.checked ? "interior" : "exterior";
      if (nextView === "interior") {
        radioInt.checked = true;
        radioInt.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        radioExt.checked = true;
        radioExt.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  // Initialize hotspot markers functionality
  initHotspotMarkers();

  // Initial sync on load
  applyView(radioExt.checked ? "exterior" : "interior");
}

function initHotspotMarkers() {
  // Use event delegation to handle all hotspot markers
  document.addEventListener("click", (e) => {
    const marker = e.target.closest(".hotspot-marker");
    if (!marker) return;

    const slideIndex = parseInt(marker.getAttribute("data-slide-index"), 10);
    const carouselId = marker.getAttribute("aria-controls");

    if (isNaN(slideIndex) || !carouselId) return;

    const carousel = document.getElementById(carouselId);
    if (!carousel) return;

    showHotspotSlide(carousel, slideIndex, marker);
  });

  // Add keyboard support for hotspot markers
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;

    const marker = e.target.closest(".hotspot-marker");
    if (!marker) return;

    e.preventDefault();
    marker.click();
  });

  // Add carousel navigation controls
  document.addEventListener("click", (e) => {
    const nextBtn = e.target.closest(".hotspot-controls__next");
    const prevBtn = e.target.closest(".hotspot-controls__prev");

    if (!nextBtn && !prevBtn) return;

    // Get the carousel that contains this button
    const carousel = e.target.closest(".hotspot-carousel");
    if (!carousel) return;

    // Get carousel ID and find corresponding markers
    const carouselId = carousel.getAttribute("id");
    const hotspotImage = document
      .querySelector(`.hotspot-marker[aria-controls="${carouselId}"]`)
      ?.closest(".hotspot-image");

    const markers = hotspotImage?.querySelectorAll(".hotspot-marker");
    if (!markers || markers.length === 0) return;

    // Find current active marker index
    const currentIndex = Array.from(markers).findIndex(
      (marker) => marker.getAttribute("aria-pressed") === "true",
    );

    // Calculate new index with wrapping
    let newIndex;
    if (nextBtn) {
      newIndex = currentIndex === markers.length - 1 ? 0 : currentIndex + 1;
    } else {
      newIndex =
        currentIndex === -1 || currentIndex === 0
          ? markers.length - 1
          : currentIndex - 1;
    }

    // Get the new marker to activate
    const newMarker = markers[newIndex];
    if (newMarker) {
      showHotspotSlide(carousel, newIndex, newMarker);
    }
  });
}

function showHotspotSlide(carousel, slideIndex, activeMarker) {
  // Only get slides within the provided carousel
  const slides = carousel.querySelectorAll(".hotspot-slide");

  // Only get markers from the same hotspot-image container
  const markers = activeMarker
    ?.closest(".hotspot-image")
    ?.querySelectorAll(".hotspot-marker");

  if (!slides.length) return;

  // Update only slides within this carousel
  slides.forEach((slide, index) => {
    const isActive = index === slideIndex;
    slide.setAttribute("aria-hidden", !isActive);
  });

  // Update only markers within the same hotspot-image
  if (markers) {
    markers.forEach((marker, index) => {
      const isActive = index === slideIndex;
      marker.setAttribute("aria-pressed", isActive);
      marker.classList.toggle("active", isActive);
    });
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  // Always run global features
  initGlobalFeatures();
  initGoogleTagEvents();
  initModalFeatures(); // Add modal functionality for all pages
  initNumberCounters();
  initAccordion();
  initSwatchControls();
  initPdpScrollIndicators();
  initToggleHotspot();

  if (
    window.matchMedia("(pointer: fine)").matches &&
    window.innerWidth >= 768
  ) {
    initCustomCursor();
  }

  // Only run home page features on home page
  if (
    document.body.classList.contains("home") ||
    document.body.classList.contains("front-page") ||
    document.body.classList.contains("page-template-front-page")
  ) {
    initHomePageFeatures();
  }
});
